export default __webpack_public_path__ + "static/media/FINAL-ROCKETS-03.fed598fc.svg";